export default __webpack_public_path__ + "static/media/upload.e3114176.svg";